import type { ProfileFeatureConfig } from './type';

export const profile: Partial<ProfileFeatureConfig> = {
    inverseNameOrder: true,
};
